/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import Office from './Office/index'
import Person from './Person/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Details.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Person
  viewPath={`${viewPath}/Person`}
/>
<Office
  viewPath={`${viewPath}/Office`}
/>
</div>
{children}
</React.Fragment>)
}